import React, { useState } from 'react';
import AuthModal from './AuthModal';
import RegisterModal from './RegisterModal';
import ForgotPasswordModal from './ForgotPasswordModal';
import ForgotUsernameModal from './ForgotUsernameModal';

function AuthPage({ onLoginSuccess, showNotification }) {
    const [authView, setAuthView] = useState('login');

    return (
        <div className="login-page-container">
            {authView === 'login' ? (
                <AuthModal onLoginSuccess={onLoginSuccess} showNotification={showNotification} setAuthView={setAuthView} />
            ) : authView === 'register' ? (
                <RegisterModal showNotification={showNotification} setAuthView={setAuthView} />
            ) : authView === 'forgot-password' ? (
                <ForgotPasswordModal showNotification={showNotification} setAuthView={setAuthView} />
            ) : authView === 'forgot-username' ? (
                <ForgotUsernameModal showNotification={showNotification} setAuthView={setAuthView} />
            ) : null}
        </div>
    );
}

export default AuthPage;
